module.exports = __webpack_public_path__ + "static/media/icon_ai_brain.7ae9c5ee.svg";